module.exports = __webpack_public_path__ + "fonts/Baewatch.c05d8dc9.otf";